module.exports = __webpack_public_path__ + "static/img/10.160bd53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/eng/10.png
// module id = ytPA
// module chunks = 0